<template>
  <v-data-table
    dense
    v-resize="onResize"
    id="time__table"
    height="25vh"
    :items-per-page="-1" 
    fixed-header
    :footer-props="{ itemsPerPageOptions: [-1] }"
    :headers="headers"
    :items="items"
    no-data-text="측정된 자료가 없습니다."
    class="table_content"
    item-key="date"
    single-select
    hide-default-footer
  >
    <template v-slot:item="{ item }">
      <tr v-if="!isMobile">
        <td class="table_line">{{ item.date }}</td>
        <td class="table_line detail"  @click="$emit('detailInfo', item.date)">
          <v-icon size="26" color="black" style="font-size:24px !important;">
            mdi-cow
          </v-icon>
        </td>

        <td class="table_line">{{ item.result.total_milking_wt }}</td>
        <td class="table_line">{{ item.result.total_milking_cnt }}</td>
        <td class="table_line">{{ item.result.milking_mtime_per_kg }}</td>
        <td class="table_line">{{ item.result.avg_mfat_rt }}</td>
        <td class="table_line">{{ item.result.avg_mprt_rt }}</td>
        <td class="table_line">{{ item.result.avg_temp }}</td>
        <td class="table_line">{{ item.result.avg_cond }}</td>

      </tr>

      <tr v-else  class="mobile_tr">
        <td class="mb_table">
          <div class="date mt-2">
            <div class="flex-title"> 착유일자</div>
            <div  @click="$emit('detailInfo', item.date)">
              <v-icon size="24" color="white">
                mdi-file-document
              </v-icon> 
              {{ item.date }}
            </div>
          </div>

          <div class="flex s-bt">
            <div class="flex-title">착유량</div>
            <div>{{ item.result.total_milking_wt }}</div>
          </div>
          <!-- <div class="line-table"></div> -->

          <div class="flex s-bt">
            <div class="flex-title">착유회차</div>
            <div>{{  item.result.total_milking_cnt }}</div>
          </div>
          <!-- <div class="line-table"></div> -->

          <div class="flex s-bt">
            <div class="flex-title">착유시간</div>
            <div>{{  item.result.milking_mtime_per_kg }}</div>
          </div>
          <!-- <div class="line-table"></div> -->

          <div class="flex s-bt">
            <div class="flex-title">지방</div>
            <div>{{  item.result.avg_mfat_rt }}</div>
          </div>
          <!-- <div class="line-table"></div> -->

          <div class="flex s-bt">
            <div class="flex-title">유단백</div>
            <div>{{  item.result.avg_mprt_rt }}</div>
          </div>
          <!-- <div class="line-table"></div> -->

          <div class="flex s-bt">
            <div class="flex-title">체온</div>
            <div>{{  item.result.avg_temp }}</div>
          </div>
          <!-- <div class="line-table"></div> -->

          <div class="flex s-bt">
            <div class="flex-title">전도도</div>
            <div>{{  item.result.avg_cond }}</div>
          </div>
          <div class="line-table"></div>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "CustomTable",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    // sortBy: {
    //   type: String,
    //   default: "entity_no",
    // },
    // sortDesc: {
    //   type: Boolean,
    //   default: true,
    // },
    search: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  methods: {
    toggleSort(column) {
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = column;
        this.sortDesc = false;
      }
    },
    addCommas(num) {
      if (typeof num === "number") {
        return num.toLocaleString();
      }
      return num;
    },
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },

  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped lang="scss">
@import '../../../style/table_mb.scss';

.table_line{
  border-right:1px solid #cfcfcf !important;
  text-align: center;
}
.text-align{
  text-align: center;
}
.v-data-table th {
  text-align: center !important;
  vertical-align: middle !important;
}
::v-deep .v-data-table-header > tr > th > span{
  font-size:14px !important;
  vertical-align: middle !important;
  letter-spacing: -2.5px !important;
}
*{
  font-size:15px !important;
}
::v-deep .mdi-arrow-up {
  display: none;
  // font-size:px !important;
}
.v-table td {
  text-align: center;
  vertical-align: middle;
}
.detail{
  cursor: pointer;
}
</style>
